module.exports = "/_next/static/images/ads-are-down-9967b18fd64690e628be323db64d22f8.svg";